var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGlobeIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 28,
    viewBox: "0 0 30 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.902344 15.4168H8.66143C8.90384 19.9031 10.3339 24.2446 12.8052 27.9967C9.70967 27.5105 6.86254 26.0122 4.70895 23.7361C2.55536 21.46 1.21673 18.5344 0.902344 15.4168ZM0.902344 12.5834C1.21673 9.46576 2.55536 6.54017 4.70895 4.26406C6.86254 1.98795 9.70967 0.48965 12.8052 0.00341797C10.3339 3.75562 8.90384 8.09704 8.66143 12.5834H0.902344ZM29.094 12.5834H21.3349C21.0925 8.09704 19.6625 3.75562 17.1912 0.00341797C20.2867 0.48965 23.1338 1.98795 25.2874 4.26406C27.441 6.54017 28.7796 9.46576 29.094 12.5834ZM29.094 15.4168C28.7796 18.5344 27.441 21.46 25.2874 23.7361C23.1338 26.0122 20.2867 27.5105 17.1912 27.9967C19.6625 24.2446 21.0925 19.9031 21.3349 15.4168H29.0954H29.094ZM11.499 15.4168H18.4973C18.2642 19.241 17.0599 22.9427 14.9982 26.1721C12.9365 22.9427 11.7322 19.241 11.499 15.4168ZM11.499 12.5834C11.7322 8.75915 12.9365 5.05747 14.9982 1.82808C17.0599 5.05747 18.2642 8.75915 18.4973 12.5834H11.499Z",
    fill: "#43B681"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobeIcon);
export default __webpack_public_path__ + "static/media/globe-icon.8478a64c4e529553e42a19eb7fa45bdd.svg";
export { ForwardRef as ReactComponent };